import { combineReducers } from 'redux';

import { location } from './allStates/location/reducer';
import { signIn } from './allStates/signIn/reducer';
import { userAuthentication } from './allStates/userAuthentication/reducer';
import { cart } from './allStates/order/reducer';
import { notifications } from './allStates/notification/reducer';

import customizer from './reducers/customizer';
import auth from './reducers/auth';
import navbar from './reducers/navbar/Index';

export default combineReducers({
    cart: cart,
    notifications: notifications,
    location: location,
    signin: signIn,
    userAuthentication: userAuthentication,
    customizer: customizer,
    auth: auth,
    navbar: navbar,
});
